import { IonButton, IonButtons, IonContent, IonIcon, IonPage, IonTitle, IonToolbar } from '@ionic/react'
import { arrowBack } from 'ionicons/icons'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router'
import ProcedureDataItem from '../../components/ProcedureDataItem'
import { COUNTRY } from '../../const/constants'
import { useAppContext } from '../../context/AppContext'

const ReferredDetail = () => {
  const prospecto = useSelector((state: any) => state.storedProcedure)
  const { settings }: any = useAppContext()
  const history = useHistory()

  return (
    <IonPage>
      <header>
        <IonToolbar>
          <IonButtons slot="start">
            <IonButton onClick={(e) => history.push('/procedures/referidos')}>
              <IonIcon slot="icon-only" icon={arrowBack} />
            </IonButton>
          </IonButtons>
          <IonTitle>Consulta de Referido</IonTitle>
        </IonToolbar>
      </header>
      <IonContent>
        <main className="detail">
          <div className="detail-container">
            <ProcedureDataItem
              label="Fecha de ingreso"
              data={new Date(prospecto?.fechaIngreso).toLocaleString('en-GB')}
            />
            {settings.country === COUNTRY.AR && <ProcedureDataItem label="Apellido" data={prospecto?.apellido} />}
            <ProcedureDataItem label="Nombre" data={prospecto?.nombre} />
            {prospecto?.documento && <ProcedureDataItem label="Número de documento" data={prospecto?.documento} />}
            <ProcedureDataItem label="Teléfono" data={prospecto?.telefono} />
            <ProcedureDataItem label="Email" data={prospecto?.email} />
            <ProcedureDataItem label="Estado" data={prospecto?.estado} />
            <ProcedureDataItem label="Negocio" data={prospecto?.negocio} />
          </div>
        </main>
      </IonContent>
    </IonPage>
  )
}

export default ReferredDetail
